import { transformObjectValuesToObject } from '@/shared/utils/transformObjectValuesToObject';
import { ValuesOf } from '@/shared/utils/types';

const SELF_EMPLOYED = 'Self Employed';

const GBPartnerType = {
  selfEmployed: SELF_EMPLOYED,
  company: 'LLP',
} as const;

const USPartnerType = {
  selfEmployed: SELF_EMPLOYED,
  company: 'Company',
} as const;

const RUPartnerType = {
  selfEmployed: SELF_EMPLOYED,
  ip: 'ИП',
  ooo: 'Юридическое лицо',
} as const;

const FRPartnerType = {
  selfEmployed: SELF_EMPLOYED,
  company: 'SAS',
} as const;

const UAEPartnerType = {
  company: 'LLC',
} as const;

type TPartnerType =
  | ValuesOf<typeof UAEPartnerType>
  | ValuesOf<typeof GBPartnerType>
  | ValuesOf<typeof USPartnerType>
  | ValuesOf<typeof RUPartnerType>
  | ValuesOf<typeof FRPartnerType>
  | ValuesOf<typeof UAEPartnerType>;

const allPartnerTypesEnum = [
  GBPartnerType,
  USPartnerType,
  RUPartnerType,
  FRPartnerType,
  UAEPartnerType,
].reduce(
  (acc, types) => ({ ...acc, ...transformObjectValuesToObject<TPartnerType>(types) }),
  {} as Record<TPartnerType, null>,
);

export {
  GBPartnerType,
  USPartnerType,
  RUPartnerType,
  FRPartnerType,
  UAEPartnerType,
  SELF_EMPLOYED,
  allPartnerTypesEnum,
};
export type { TPartnerType };
